<template>
    <div id="event-group">
        <div class="row topactionform smallmargin">
            <div class="col-xs-4">
                <div class="smalltitle">Daily Sales</div>
            </div>
            <div class="col-xs-8">
                <form class="onelineform flowsearch" @submit.prevent="submitSearchBill">
                    <button type="submit" class="submit btn light" style="float: right; width: 10%"><i
                            class="fa fa-search"></i></button>
                    <span class="selectwrap" style="width: 15%; float: right">
                        <select>
                            <option value="">Itemized bills</option>
                            <option value="">Registration fee</option>
                            <option value="">Additional fee</option>
                            <option value="">Sponsorship</option>
                            <option value="">Membership</option>
                            <option value="">EMR Pro Package</option>
                            <option value="">EMR Pro with e-prescribe</option>
                            <option value="">EMR Complete suite</option>
                        </select>
                    </span>
                    <span class="selectwrap" style="width: 15%; float: right">
                        <select>
                          <option value="">Type</option>
                          <option value="">Membership</option>
                          <option value="">Event</option>
                          <option value="">Patient bill</option>
                          <option value="">EMR</option>
                        </select>
                    </span>
                    <span class="selectwrap" style="width: 15%; float: right">
                        <select>
                          <option value="">Vendor</option>
                          <option value="">WikiAllergies</option>
                          <option value="">Group</option>
                          <option value="">Clinic</option>
                        </select>
                    </span>
                    <date-picker
                            format="MM/DD/YYYY"
                            :clearable="true"
                            :append-to-body=true
                            :custom-button=true
                            style="float: right;">
                    </date-picker>
                    <input type="text" placeholder="MRN, patient name or leave blank for search all"
                           class="keyinput" style="width: 28%; border-left: 1px solid #e1e1e1; float: right">
                </form>
            </div>
        </div>

        <ul class="itemlisttable flowlisttype messageflow">
            <li class="itemlisthead">
                <div style="width: 75px !important; text-align: right !important;">Date</div>
                <div style="width: 5% !important; text-align: center !important;">Type</div>
                <div style="width: 5% !important; text-align: left;">Bill#</div>
                <div style="width: 10% !important; text-align: left;">Vendor</div>
                <div style="width: 10% !important; text-align: left;">User</div>
                <div style="width: 20% !important; text-align: left">Listing</div>
                <div style="width: 27% !important;">Itemized Listing</div>
                <div style="width: 10% !important; text-align: right !important;">Amount</div>
                <div style="width: 5% !important; text-align: right !important;">Status</div>
                <div style="width: 3% !important; text-align: right !important; padding-right: 10px !important;"></div>
            </li>
            <li v-if="isLoading" style="text-align: center; color: #d9df20; font-size: 16pt">
                <i class="fas fa-spinner fa-spin"></i>
            </li>
            <li v-if="!isLoading && dataEvents.length === 0" style="text-align: center; font-size: 16pt">No records
                found
            </li>

            <li v-if="!isLoading" v-for="(event, index) in dataEvents" @click.prevent="showDetail(event)">
                <div style="width: 75px !important; font-style: normal !important; text-align: right !important;">
                    <span>{{ formatTime(event.paidDate)}}</span>
                    <span style="display: block">{{ formatOnlyTime12Hour(event.paidDate)}}</span>
                </div>
                <div style="width: 5% !important; font-style: normal !important; text-align: center !important;">Event
                </div>
                <div style="width: 5% !important; text-align: left;">#{{ event.billId }}</div>
                <div style="width: 10% !important; text-align: left; text-transform: uppercase !important;"><i
                        class="fas fa-user"></i> <b style="margin-left: 5px">{{ event.groupName }}</b></div>
                <div style="width: 10% !important; text-align: left;"><i class="fas fa-user"></i> {{ event.attendant }}
                </div>
                <div style="width: 20% !important; text-align: left"><span>{{ event.title }}</span></div>
                <div style="width: 27% !important; min-height: 1px !important;">
                    <ul class="itemsublist billing-icd" v-if="event.categorySponsor">
                        <li>
                            <span>{{ event.categorySponsor}}: {{ formatStringToView(event.total_ticket) }}</span>
                        </li>
                        <!--<li>-->
                            <!--<span>Exhibitors: {{ formatStringToView(event.amount - event.total_ticket) }}</span>-->
                        <!--</li>-->
                    </ul>
                    <ul class="itemsublist billing-icd" v-if="event.ticketName">
                        <li v-if="event.ticketName">
                            <span>{{ event.ticketName}}: {{ formatStringToView(event.total_ticket) }}</span>
                        </li>
                        <li v-if="event.hotel">
                            <span>{{ event.hotel }}: {{ formatStringToView(event.price_hotel) }}</span>
                        </li>

                        <li v-if="event.addition_title">
                            <span>{{ event.addition_title }}: {{ formatStringToView(event.addition_amount) }}</span>
                        </li>
                    </ul>
                </div>
                <div style="width: 10% !important; text-align: right !important;">{{ formatStringToView(event.amount)}}</div>
                <div style="width: 5% !important; text-align: right !important; min-height: 1px;" :title="event.transaction_reason_error">{{event.transactionStatusText}}</div>
                <div style="width: 3% !important; text-align: right !important; min-height: 1px; padding-right: 10px !important;">
                    <dropdown>
                        <a href="javascript:void(0)" class="recorddelete"><i
                                class="fa fa-cog"></i></a>
                        <template slot="dropdown"></template>
                    </dropdown>
                </div>
            </li>
        </ul>
        <br/>
        <pagination :currentPage="paginate.page" :perPage="paginate.perPage" @updatePerPage="updatePerPage"
                    :totalPages="paginate.totalPages" :total="paginate.total"></pagination>

        <detail-ticket-event v-if="detailTicket.modal" :detailTicket="detailTicket.data"
                             @updateModal="detailTicket.modal = $event"></detail-ticket-event>
        <detail-ticket-sponsor v-if="detailSponsor.modal" :detailTicket="detailSponsor.data"
                               @updateModal="detailSponsor.modal = $event"></detail-ticket-sponsor>
    </div>
</template>

<script>
import axios from '../../client'
import Common from '../mixins/Common.vue'
import Pagination from '../../global/Pagination.vue'
import DatePicker from '../../global/datepicker/DatePickerCustom.vue'
import DetailTicketEvent from '../billing/part/DetailTicketEvent'
import DetailTicketSponsor from '../billing/part/DetailTicketSponsor'
import moment from 'moment'

export default {
  name: 'calendar-daily',
  components: { Pagination, DatePicker, DetailTicketEvent, DetailTicketSponsor },
  mixins: [Common],
  data () {
    return {
      key_search: '',
      isLoading: false,
      dataEvents: [],
      paginate: {
        perPage: 10,
        page: 1,
        totalPages: 10,
        total: 0
      },
      isGeneratingCode: false,
      postEventDate: '',
      endEventDate: '',
      formSearch: {
        keySearch: '',
        fromDate: moment().subtract(1, 'months'),
        toDate: moment()
      },
      detailTicket: {
        data: {},
        modal: false
      },
      detailSponsor: {
        data: {},
        modal: false
      }
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    submitSearchBill () {
      this.paginate.page = 1
      this.loadData()
    },
    loadData () {
      if (!this.isLoading) {
        let params = {
          page: this.paginate.page,
          perPage: this.paginate.perPage,
          key: this.formSearch.keySearch,
          fromDate: this.formSearch.fromDate ? moment(this.formSearch.fromDate).format('MM/DD/YYYY') : '',
          toDate: this.formSearch.toDate ? moment(this.formSearch.toDate).format('MM/DD/YYYY') : ''
        }
        this.isLoading = true
        axios.get(`calendar/daily-list`, { params: params }).then(response => {
          this.isLoading = false
          if (response.data.s === 200) {
            this.dataEvents = response.data.data.bills
            this.paginate.total = Number(response.data.data.total)
            this.paginate.totalPages = Math.ceil(this.paginate.total / this.paginate.perPage)
          } else {
            this.dataEvents = []
            this.alertError(response.data.msg)
          }
        }).catch(e => {
          this.isLoading = false
          this.alertError('Server error when load data. Press F5 to refresh browser')
        })
      }
    },
    updatePerPage (data) {
      this.paginate.perPage = data.perPage
      this.paginate.page = data.currentPage
      this.loadData()
    },
    showDetail (billing) {
      axios.post(`events-billing/get-detail`, { id: billing.billId }).then(response => {
        if (response.data.s === 200) {
          let data = response.data.data
          if (data.type === 'ticket') {
            this.detailTicket = {
              data: data,
              modal: true
            }
          } else {
            this.detailSponsor = {
              data: data,
              modal: true
            }
            console.log('data', data)
          }
        } else {
          this.alertError(response.data.msg)
        }
      }).catch(e => {
        this.alertError('Server error when load data. Press F5 to refresh browser')
      })
    }
  }
}
</script>

<style>
    #event-group .mx-datepicker {
        width: 17%;
    }

    #event-group .mx-input {
        height: 40px;
    }
</style>
